import React, { useEffect, useState } from "react";
import { Modal, Alert } from "react-bootstrap";
import classNames from "classnames";
import { useMerchant } from "../../context/merchant";
import ProductTable from "./productTable";
import OrderInfo from "./orderInfo";
import OrderDetailsButtons from "./detailsBtns";
import DriverPanel from "./driverPanel";
import { fetchOrderDetails, updateOrderStatus } from "../../api/axios/requests";
import OrderDetailsShimmer from "./shimmer";

export default function OrderDetailsModal({ show, handleClose, orderId }) {
  const { isFullScreen, pollOrders } = useMerchant();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [updating, setUpdating] = useState(false);

  // Fetch order details when modal opens
  useEffect(() => {
    if (show && orderId) {
      loadOrderDetails(orderId);
    }
  }, [show, orderId]);

  const loadOrderDetails = async (id) => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchOrderDetails({ orderId: id });
      if (res?.success && res?.data) {
        setData(res.data);
      } else {
        setError(res?.message || "Захиалгын мэдээлэл татаж чадсангүй.");
      }
    } catch (err) {
      console.error("fetchOrderDetails error:", err);
      setError("Захиалгын мэдээлэл татаж чадсангүй.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (statusId, prepDuration) => {
    setUpdating(true);
    try {
      const res = await updateOrderStatus({
        orderId,
        statusId,
        prepDuration,
      });

      if (res?.success) {
        handleClose();
        /* Хуудсыг бүхэлд нь дахин ачаалахын оронд жагсаалтыг л шинэчилнэ
           (2026-09-17) — тоолуур одоо серверээс ирдэг тул reload шаардлагагүй. */
        pollOrders({ silent: true });
      } else {
        console.error(res?.message || "Order-ийн төлөв шинэчлэл амжилтгүй.");
      }
    } catch (error) {
      console.error("Order status update error:", error);
    } finally {
      setUpdating(false);
    }
  };


  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      fullscreen
      className={classNames({ fullScreenText: isFullScreen })}
    >
      <Modal.Body>
        {loading ? (
          <OrderDetailsShimmer />
        ) : error ? (
          <Alert variant="danger" className="m-4">
            {error}
          </Alert>
        ) : (
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-8">
                  <div className="card">
                    <div className="card-body pt-0">
                      <ProductTable products={data?.products} address={`${data?.district?.name ?? ""} ${data?.address ?? ""}`} 
                      phone={data?.phone} etype={data?.ebarimtType} ebarimt={data?.ebarimtRegister
}/>
                    </div>
                  </div>
                </div>
                <div className="col-4 stick">
                  <div className="card">
                    <div className="card-body">
                      <OrderInfo data={data} />
                    </div>
                  </div>
                  {/* Жолооч ирж байна / ирсэн + газрын зураг (2026-09-17). */}
                  {data?.driverId && [2, 3, 4].includes(Number(data?.status?.id)) ? (
                    <DriverPanel orderId={data.id} />
                  ) : null}
                  <OrderDetailsButtons
                    handleUpdateStatus={handleUpdateStatus}
                    loading={updating}
                    isFullScreen={isFullScreen}
                    handleClose={handleClose}
                    statusId={data?.status?.id}
                    orderId={data?.id}
                    extendable={
                      Number(data?.status?.id) === 3 &&
                      !!data?.prepStartedAt &&
                      Number(data?.prepExtendCount || 0) < 1
                    }
                    onExtended={() => loadOrderDetails(data.id)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
